// extracted by mini-css-extract-plugin
export default {"containedLoader":"PageLoader_containedLoader__V6zxu"};